/*
 * @Author: wsx
 * @Date: 2022-01-19 09:28:58
 * @LastEditTime: 2022-01-19 17:49:18
 * @LastEditors: your name
 * @Description:
 */
import request from "@/utils/request.js";

// http://180.167.172.122:6405/hz-smart-community/house/weg/list?
// 获取房屋水电煤气列表
export const houseWeg = data => {
  return request({
    url: "/api/hz-smart-community/house/weg/list",
    params: data,
    method: "get",

  });
};
// http://180.167.172.122:6405/hz-smart-community/house/info/listWarning
// 获取群租列表
export const listWarning = data => {
  return request({
    url: "/api/hz-smart-community/house/info/listWarning",
    params: data || {},
    method: "get",
  });
};


// 获取路径策略
export const pathStrategy = data => {
  return request({
    url: "/apiData/hz-data-community/zghz/vehicle-analysis/path_strategy",
    data: data,
    method: "post",

  });
};

